import type { FinancialSnapshot } from "./types";

export const seedSnapshot: FinancialSnapshot = {
  schemaVersion: 3,
  updatedAt: "2026-08-22T00:00:00.000Z",
  source: "seed",
  periodLabel: "Agosto Q2-2026",
  periodStart: "2026-08-15",
  periodEnd: "2026-08-29",
  periodDaysRemaining: 8,
  accounts: [
    { id: "nu", name: "Nu", balanceCents: 5_491_199, accent: "violet" },
  ],
  weeks: [
    {
      id: "week1",
      label: "Semana 1",
      availableCents: 0,
      spentCents: 799_541,
      budgetCents: 743_409,
      dateRange: "15/08 — 21/08",
      status: "closed",
    },
    {
      id: "week2",
      label: "Semana 2",
      availableCents: 299_150,
      spentCents: 550,
      budgetCents: 299_700,
      dateRange: "22/08 — 29/08",
      status: "active",
    },
  ],
  savingsCents: 551_251,
  protectedSavingsCents: 0,
  savingsThisPeriodCents: 56_182,
  yieldCents: 632_163,
  temporaryContributionCents: 1_465_373,
  totalSpentCents: 743_909,
  totalBudgetCents: 1_043_109,
  cardPayments: [
    { name: "BBVA", amountCents: 0 },
    { name: "Scotiabank", amountCents: 88_900 },
    { name: "AMEX Servicios", amountCents: 2_454_312 },
  ],
  categorySpend: [
    { name: "Ropa y accesorios", amountCents: 228_531, icon: "◈" },
    { name: "Comidas fuera", amountCents: 130_849, icon: "🍽" },
    { name: "Mascotas", amountCents: 75_820, icon: "🐾" },
    { name: "Regalos", amountCents: 65_900, icon: "🎁" },
    { name: "Hogar y mantenimiento", amountCents: 65_819, icon: "⌂" },
    { name: "Ocio y salidas", amountCents: 52_700, icon: "✦" },
    { name: "Cafés, bebidas y snacks", amountCents: 49_200, icon: "☕" },
    { name: "Salud y bienestar", amountCents: 36_300, icon: "♡" },
  ],
  movements: [
    {
      id: "seed-metro",
      kind: "expense",
      amountCents: 500,
      merchant: "Metro a Chapultepec de Alex",
      paymentMethod: "AMEX Servicios",
      weekId: "week2",
      category: "Transporte",
      createdAt: "2026-08-22T12:00:00.000Z",
      syncState: "synced",
    },
    {
      id: "seed-castillo",
      kind: "expense",
      amountCents: 10_500,
      merchant: "Castillo de Chapultepec",
      paymentMethod: "Scotiabank",
      weekId: "week1",
      category: "Ocio y salidas",
      createdAt: "2026-08-21T18:30:00.000Z",
      syncState: "synced",
    },
    {
      id: "seed-casa-tono",
      kind: "expense",
      amountCents: 13_680,
      merchant: "Casa de Toño Lalo",
      paymentMethod: "Scotiabank",
      weekId: "week1",
      category: "Comidas fuera",
      reimbursementCents: 23_700,
      createdAt: "2026-08-21T15:00:00.000Z",
      syncState: "synced",
    },
    {
      id: "seed-pasteles",
      kind: "expense",
      amountCents: 15_000,
      merchant: "Pasteles",
      paymentMethod: "AMEX Servicios",
      weekId: "week1",
      category: "Cafés, bebidas y snacks",
      createdAt: "2026-08-21T12:00:00.000Z",
      syncState: "synced",
    },
  ],
};
